export default "dist/images/block-testimonial-bubble.9537d2a.png";